import { HospiceOrganizationResponse } from "./OrderSetModels";
import { TeamResponse } from "./AppointmentModels";

export interface GetSystemOperationRecordPaginationRequest {
    pageNumber?: number;
    pageSize?: number;
    type?: SystemOperationRecordTypeEnum | null;
    occuredAtFrom?: string | null;
    occuredAtTo?: string | null;
    patientHcrxCode?: string | null;
    details?: string | null;
}

export interface SystemOperationRecordResponse {
    id: string;
    type: SystemOperationRecordTypeEnum;
    occuredAt: string;
    details?: string | null;
    patientHcrxCodes: string[];
    organizationDetails: HospiceOrganizationResponse;
    teamDetails?: TeamResponse | null;
}

export enum SystemOperationRecordTypeEnum {
    AllergyImportIssue = 0,
    CR8358 = 1,
}

export const SystemOperationTypeOptions = [
    {
        label: 'Allergy Import Issue',
        value: SystemOperationRecordTypeEnum.AllergyImportIssue,
    },
    {
        label: 'CR 8358',
        value: SystemOperationRecordTypeEnum.CR8358,
    },
];

export interface ExportSystemOperationRecordRequest {
  type?: SystemOperationRecordTypeEnum;
  from?: string | Date;
  to?: string | Date;
}
